import StoreInfoModalContainer from 'features/store/components/store-info-modal';

export default function StoreDetailsByIdPage() {
  return <StoreInfoModalContainer />;
}
